import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loggedUser, updateUserProfile } from '../../../redux/authSlice';
import useUserLocation from "../../Hooks/useUserLocation";
import { toast } from 'react-toastify';
import { FaLocationArrow, FaCrosshairs } from "react-icons/fa";

const EditProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user = {}, error, loading, success, message } = useSelector((state) => state.auth || {});
  const { coordinates, address, loading: locationLoading, error: locationError } = useUserLocation();
  const [currentLocation, setCurrentLocation] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    whatsappNumber: '',
    email: '',
    gender: '',
    dob: '',
    homeAddress: address || '',
    officeAddress: ''
  });
  const token = localStorage.getItem("token")
  if (!token) { navigate("/"); }

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch(loggedUser(token)).catch((err) => toast.error(err.message));
    }
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || '',
        whatsappNumber: user.whatsappNumber || '',
        email: user.email || '',
        gender: user.gender || '',
        dob: user.dob || '',
        homeAddress: user.homeAddress || '',
        officeAddress: user.officeAddress || ''
      });
    }
  }, [user, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updatedData = { ...formData, _id: user._id }; // Add user ID to ensure correct profile is updated
      const result = await dispatch(updateUserProfile(updatedData)).unwrap();

      if (result) {
        toast.success(message);
      }
    } catch (error) {
      toast.error(error?.message || "Failed to update profile.");
    }
  };

  const userLocactionHandle = () => {
    setCurrentLocation(formData.homeAddress = address || '');
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-lg-left">
        <Col md={4}>
          <Card className="p-3 shadow-sm bg-white rounded">
            <Link to="/my/profile" className="text-decoration-none">Profile</Link>
            <Link to="/my/order" className="text-decoration-none">Order</Link>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="p-4 shadow-sm bg-white rounded">
            <h3 className="text-center mb-4">Edit Profile</h3>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={6}>
                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label><strong>Email</strong></Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter email address"
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mb-3" controlId="name">
                    <Form.Label><strong>Name</strong></Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3" controlId="whatsappNumber">
                    <Form.Label><strong>WhatsApp Number</strong></Form.Label>
                    <Form.Control
                      type="text"
                      name="whatsappNumber"
                      value={formData.whatsappNumber}
                      onChange={handleChange}
                      placeholder="Enter WhatsApp number"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mb-3" controlId="gender">
                    <Form.Label><strong>Gender</strong></Form.Label>
                    <Form.Select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mb-3" controlId="dob">
                    <Form.Label><strong>Date of Birth</strong></Form.Label>
                    <Form.Control
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col lg={12}>
                  {/* {currentLocation} */}
                  {locationLoading && <Spinner animation="border" />}
                  <Form.Group className="mb-3" controlId="homeAddress" style={{ position: "relative" }}>
                    <Form.Label><strong>Home Address</strong></Form.Label>
                    <Form.Control
                      type="text"
                      name="homeAddress"
                      value={formData.homeAddress}
                      onChange={handleChange}
                      required
                    />
                    <FaCrosshairs onClick={userLocactionHandle} style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(10%)", cursor: "pointer", fontSize: "25px", color: "orange" }} />
                  </Form.Group>
                </Col>
                <Col lg={12}>
                  <Form.Group className="mb-3" controlId="officeAddress">
                    <Form.Label><strong>Office Address</strong></Form.Label>
                    <Form.Control
                      type="type"
                      name="officeAddress"
                      value={formData.officeAddress}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col lg={12} >
                  <div className="text-center mt-3">
                    <Button variant="primary" type="submit" className="w-50">
                      Update Profile
                    </Button>
                  </div>

                </Col>
              </Row>


            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default EditProfile;
